import React from 'react';
import {makeStyles, Box, Grid} from '@material-ui/core';
import axios from 'axios';
import { MathJaxContext, MathJax } from "better-react-mathjax";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {API_URL, OPENAI_API_KEY} from '../utils/EnvVars';
import '../styles/bizofficer-a.css';

const config = {
	/* in theory, the MathML input processor should be activated if we add
	an "mml" block to the config OR if "input/mml" (NOT "input/mathml" as stated 
	in the docs) is in the load array. However, this is not necessary as MathML is 
	ALWAYS enabled in MathJax */
	loader: { load: ["input/mml", "output/chtml"] },
	mml: {}
  };

  const useStyles = makeStyles({
    dialog: {
      position: 'absolute',
      left: 0,
      
    },
  });

  function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }
  

function DialogHelp(props, ref) {  
  const classes = useStyles();
	///var selectedCourse = localStorage.getItem('etlSelectCourse'); 	
	///var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
  var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));

  const [open, setOpen] = React.useState(false);
  const [showProgress, setShowProgress] = React.useState(false);
  const [aisolution, setAisolution] = React.useState("");
  const [callOpenAIFlag, setCallOpenAIFlag] = React.useState(false);
  const [callSaveAnsFlag, setCallSaveAnsFlag] = React.useState(false);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };


  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  React.useEffect(() => {
    setAisolution("");
    setCallOpenAIFlag(false);
    setCallSaveAnsFlag(false);    
    if(open){
      callApiToGetSavedAnswer();
    }
	}, [open,props.searchQuery,props.currentQuestionObj]); 

	

  React.useEffect(() => {
    if(open && callSaveAnsFlag){
      ///alert("callApiToSaveAnswer: ==="+callSaveAnsFlag);
      callApiToSaveAnswer();      
    }else if(open && callOpenAIFlag){
      ///alert("callOpenAIToGetAnswer: ==="+callOpenAIFlag);
      callOpenAIToGetAnswer();
    } 
  }, [open,callSaveAnsFlag,callOpenAIFlag]); 

  async function callOpenAIToGetAnswer(){    
    const alphaArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    let options = "";
    if(props.currentQuestionObj.responseChoice && props.currentQuestionObj.responseChoice.length>0){
      for(let i=0; i<props.currentQuestionObj.responseChoice.length; i++){
        options += "\n"+alphaArr[i]+". "+props.currentQuestionObj.responseChoice[i].responseText;
      }
    }

    let axiosHeader = {
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Authorization': `Bearer ${OPENAI_API_KEY}`,
      }
    };    
    // gpt-3.5-turbo gpt-4-1106-preview gpt-4-vision-preview
    const data = JSON.stringify({
      model: "o3-mini",
      reasoning_effort: "medium", // Ensures deep logical reasoning
      tools: [
        {
          type: "function",
          function: { name: "web_search" }, // ✅ Correctly specifying the function
        },
      ], // Enables live search for citations
      tool_choice: "auto", // Lets the model decide when to search
      messages: [
        {
          role: "system",
          content:
            "First explain the concept in detail. In second step, analyse all the options explaining why they are correct or incorrect and finally arrive at correct answer. Thereater, give citations first from books, then from articles and lastly research papers without links. Send a structured html body as response to be rendered on page with no styling properties.",
        },
        { role: "user", content: props.currentQuestionObj.questionBody+options },
      ],
    });
    axios.post('https://api.openai.com/v1/chat/completions', data, axiosHeader)
       .then(response => {
      if(response.data && response.data.choices && response.data.choices[0].message.content){
          setAisolution(response.data.choices[0].message.content);          
          setShowProgress(false);
          setCallOpenAIFlag(false);
          setCallSaveAnsFlag(true);
      }	 				
    })
  }

  async function callApiToSaveAnswer(){    
    let axiosHeader = {
      headers:{
        'Content-Type': 'multipart/mixed',
        'loginId': etlStudentObj.loginId,
        'token': etlStudentObj.token,
        'device': 'web'
      }
    };        
    const data = new FormData();
    if(props.currentQuestionObj.questionDisplayId){
      data.append("questionDisplayId", props.currentQuestionObj.questionDisplayId);
    }else{
      data.append("questionDisplayId", '');
    }
    if(props.currentQuestionObj.questionId && props.currentQuestionObj.questionId>0){
      data.append("questionId", props.currentQuestionObj.questionId);
    }else{
      data.append("questionId", 0);
    }
    if(props.currentQuestionObj.itemId && props.currentQuestionObj.itemId>0){
      data.append("itemId", props.currentQuestionObj.itemId);
    }else{
      data.append("itemId", 0);
    }		
    data.append("solution", aisolution);
    data.append("topicId", props.currentQuestionObj.topicId);
    axios.post(API_URL +'/openai-addnew', data, axiosHeader)
       .then(response => {
        if(response && response.status === 200 && response.data.responseTxt === "success"){
          console.info("Saved Answer");
          setCallSaveAnsFlag(false);
        }	 				
    })
  }

  async function callApiToGetSavedAnswer_old(){
    if(!aisolution){  
      setShowProgress(true);      
      let axiosHeader = {
        headers:{
          'Content-Type': 'multipart/mixed',
          'loginId': etlStudentObj.loginId,
          'token': etlStudentObj.token,
          'device': 'web'
        }
      };       
      let itemId = 0;
      if(props.currentQuestionObj.itemId && props.currentQuestionObj.itemId>0){
        itemId = props.currentQuestionObj.itemId;
      } 
      axios.get(API_URL +'/openai-list?questionId='+props.currentQuestionObj.questionId+'&itemId='+itemId, axiosHeader)
        .then(response => { 
        if(response && response.status === 200 && response.data.responseTxt === "success"){
          setAisolution(response.data.obj.solution);
          setShowProgress(false);
        }else{
          setCallOpenAIFlag(true);
        }	 				
      })
    }
  }

  async function callApiToGetSavedAnswer(){
    if(!aisolution){  
      setShowProgress(true);      
      let axiosHeader = {
        headers:{
          'Content-Type': 'multipart/mixed',
          'loginId': etlStudentObj.loginId,
          'token': etlStudentObj.token,
          'device': 'web'
        }
      };       
      let itemId = 0;
      if(props.currentQuestionObj.itemId && props.currentQuestionObj.itemId>0){
        itemId = props.currentQuestionObj.itemId;
      } 
      axios.get(API_URL +'/app/studentpanel/openai?questionId='+props.currentQuestionObj.questionId+'&itemId='+itemId, axiosHeader)
        .then(response => { 
          setShowProgress(false);
        if(response && response.status === 200 && response.data.responseTxt === "success"){
          setAisolution(response.data.obj.solution);          
        }else{
          setAisolution("It could not find solution for some reason. Try after sometime");
        }	 	 				
      })
    }
  }



 
  return (
    <>      
      <Dialog 
        classes={{
          paper: classes.dialog
        }}
        open={open}
        onClose={handleClose}
        scroll={'paper'}
        key={'help123'}
        aria-labelledby="draggable-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth 
        maxWidth="md"
        PaperComponent={PaperComponent}        
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title" >Help</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          title='Close'
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers={'paper'}          
        >
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1} 
          >
								<Box component="form" noValidate >
                  <div className="materialBox" >

                        {showProgress?<div style={{float:'none', fontSize: 12}} ><CircularProgress style={{width:20,height:20}} />Please wait i am working to help you</div>
                        :(!showProgress && aisolution && aisolution.length>0)?<>                          
                          <div style={{float:'none',verticalAlign:'top'}}>
                            <MathJaxContext version={3} config={config}><MathJax><div className="aiSolution_body" dangerouslySetInnerHTML={{ __html: aisolution}} /></MathJax></MathJaxContext>
                          </div>
                          </>
                        :<>                        
                        </>}                     
                    
                  </div>	
							</Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button className='helpbtn desktop-section' variant={'text'} size='small' onClick={handleClose} title='Close' >Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default React.forwardRef(DialogHelp);